// extracted by mini-css-extract-plugin
export default {"storeProducts":"StoreProducts_storeProducts__ZhwN9"};